import React, { useState, useEffect, useRef } from "react";
import { Toaster, toast } from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import {
  fetchStateData,
  fetchDistrictData,
  fetchLocationData,
  fetchCityData,
  fetchMeadiaSourceData,
  fetchAllSubMediaSource,
  createLead,
  fetchAllowedMenus,
  fetchUserData,
  User,
} from "../Services/APIService";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";

interface State {
  stateId: number;
  stateName: string;
  isActive: boolean;
}

interface MenuItem {
  menuID: number;
  menuName: string;
  menuUrl: string;
  icon: string;
  subMenuList?: [];
}

interface MediaSource {
  sourceId: number;
  sourceName: string;
  isActive: boolean;
}

interface SubMediaSource {
  mediaSourceID: number;
  name: string;
  id: number;
  isActive: boolean;
}

interface District {
  districtId: number;
  districtName: string;
  stateId: number;
  stateName: string;
  isActive: boolean;
}

interface Location {
  locationID: number;
  locationName: string;
  stateID: number;
  stateName: string;
  districtID: number;
  districtName: string;
  cityID: number;
  cityName: string;
  isActive: boolean;
}

interface City {
  cityId: number;
  cityName: string;
  districtId: number;
  districtName: string;
  stateId: number;
  stateName: string;
  isActive: boolean;
}

interface FormData {
  firstName: string;
  lastName: string;
  gender: string;
  dob: string;
  dom: string;
  mobile: string;
  email: string;
  address: string;
  stateId: number;
  districtId: number;
  cityId: number;
  zipCode: number | string;
  sourceId: number;
  subSourceId: number;
  currentStatus: number;
  incomeFrom: number | string;
  incomeTo: number | string;
  initialAssignedUser: number;
  currentAssignedUser: number;
  tenantId: number;
  createdBy: number;
  assignType: string;
}

interface ValidationErrors {
  firstName?: string;
  lastName?: string;
  gender?: string;
  dob?: string;
  dom?: string;
  mobile?: string;
  email?: string;
  address?: string;
  stateId?: string;
  districtId?: string;
  cityId?: string;
  zipCode?: string;
  sourceId?: string;
  subSourceId?: string;
  incomeFrom?: string;
  incomeTo?: string;
  assignType?: string;
  initialAssignedUser?: string;
  submitError?: string;
  fetchStateError?: string;
  fetchDistrictError?: string;
}

interface NominatimResult {
  place_id: number;
  display_name: string;
  lat: string;
  lon: string;
  type: string;
  address: {
    road?: string;
    city?: string;
    town?: string;
    village?: string;
    state?: string;
    country?: string;
    postcode?: string;
    suburb?: string;
    neighbourhood?: string;
    city_district?: string;
    state_district?: string;
    county?: string;
  };
}

const CreateLeadForm: React.FC = () => {
  const [states, setStates] = useState<State[]>([]);
  const [allDistricts, setAllDistricts] = useState<District[]>([]);
  const [filteredDistricts, setFilteredDistricts] = useState<District[]>([]);
  const [allCities, setAllCities] = useState<City[]>([]);
  const [filteredCities, setFilteredCities] = useState<City[]>([]);
  const [searchResults, setSearchResults] = useState<NominatimResult[]>([]);
  const [locations, setLocations] = useState<Location[]>([]);
  const [filteredLocation, setFilteredLocation] = useState<Location[]>([]);
  const [mediaSource, setMediaSource] = useState<MediaSource[]>([]);
  const [subMediaSource, setSubMediaSource] = useState<SubMediaSource[]>([]);
  const [assignedUser, setAssignedUser] = useState<User[]>([]);
  const [filteredSubMediaSource, setFilteredSubMediaSource] = useState<
    SubMediaSource[]
  >([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<ValidationErrors>({});
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const [isLoadingDistricts, setIsLoadingDistricts] = useState(false);
  const [isLoadingCities, setIsLoadingCities] = useState(false);
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [isLoadingSourceMedia, setIsLoadingSourceMedia] = useState(false);
  const [isLoadingSubSourceMedia, setIsLoadingSubSourceMedia] = useState(false);
  const searchTimeout = useRef<NodeJS.Timeout | null>(null);
  const searchResultsRef = useRef<HTMLDivElement>(null);
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [allowedMenus, setAllowedMenus] = useState<MenuItem[]>([]);
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
  const [activeTab, setActiveTab] = useState("home");
  const location = useLocation();
  const [selectedAssignUserId, setSelectedAssignUserId] = useState<
    number | null
  >(null);

  const navigate = useNavigate();
  const [formData, setFormData] = useState<FormData>({
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    dom: "",
    mobile: "",
    email: "",
    address: "",
    stateId: 0,
    districtId: 0,
    cityId: 0,
    zipCode: "",
    sourceId: 0,
    subSourceId: 0,
    currentStatus: 0,
    incomeFrom: "",
    incomeTo: "",
    initialAssignedUser: 0,
    currentAssignedUser: 0,
    tenantId: 0,
    createdBy: 0,
    assignType: "assign",
  });

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingStates(true);
      setIsLoadingDistricts(true);
      setIsLoadingCities(true);
      setIsLoadingLocation(true);
      setIsLoadingSourceMedia(true);
      setIsLoadingSubSourceMedia(true);

      try {
        const stateData = await fetchStateData();
        setStates(stateData);

        const districtData = await fetchDistrictData();
        setAllDistricts(districtData);

        const cityData = await fetchCityData();
        setAllCities(cityData);

        const mediaSource = await fetchMeadiaSourceData();
        setMediaSource(mediaSource);

        const subMediaSourceList = await fetchAllSubMediaSource();
        setSubMediaSource(subMediaSourceList);

        const assignUserList = await fetchUserData();
        setAssignedUser(assignUserList);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoadingStates(false);
        setIsLoadingDistricts(false);
        setIsLoadingCities(false);
        setIsLoadingLocation(false);
        setIsLoadingSourceMedia(false);
        setIsLoadingSubSourceMedia(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (formData.stateId && allDistricts.length > 0) {
      const districts = allDistricts.filter(
        (district) => district.stateId === formData.stateId
      );
      setFilteredDistricts(districts);
      if (
        formData.districtId &&
        !districts.some((d) => d.districtId === formData.districtId)
      ) {
        setFormData((prev) => ({
          ...prev,
          districtId: 0,
          cityId: 0,
        }));
      }
    } else {
      setFilteredDistricts([]);
      setFormData((prev) => ({
        ...prev,
        districtId: 0,
        cityId: 0,
      }));
    }
  }, [formData.stateId, allDistricts]);

  useEffect(() => {
    if (formData.districtId && allCities.length > 0) {
      const cities = allCities.filter(
        (city) => city.districtId === formData.districtId
      );
      setFilteredCities(cities);
      if (
        formData.cityId &&
        !cities.some((c) => c.cityId === formData.cityId)
      ) {
        setFormData((prev) => ({
          ...prev,
          cityId: 0,
        }));
      }
    } else {
      setFilteredCities([]);
      setFormData((prev) => ({
        ...prev,
        cityId: 0,
      }));
    }
  }, [formData.districtId, allCities]);

  useEffect(() => {
    if (formData.sourceId && subMediaSource.length > 0) {
      const source = subMediaSource.filter(
        (src) => src.mediaSourceID === formData.sourceId
      );
      setFilteredSubMediaSource(source);
      if (!source.some((s) => s.mediaSourceID === formData.sourceId)) {
        setFormData((prev) => ({
          ...prev,
          subSourceId: 0,
        }));
      }
    } else {
      setFilteredSubMediaSource([]);
      setFormData((prev) => ({
        ...prev,
        subSourceId: 0,
      }));
    }
  }, [formData.sourceId, subMediaSource]);

  useEffect(() => {
    const getMenus = async () => {
      setIsLoading(true);
      try {
        const menuID = location.state?.menuID;
        const previousMenuID = localStorage.getItem("activeMenuID");
        if (menuID !== previousMenuID || menuID === null) {
          localStorage.setItem("activeMenuID", menuID);
        } else {
          localStorage.removeItem("activeMenuID");
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getMenus();
  }, []);

  const requiredField = <span className="text-danger ms-1">*</span>;

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile: string): boolean => {
    const mobileRegex = /^\d+$/;
    return mobileRegex.test(mobile);
  };

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;

    const numberFields = [
      "zipCode",
      "incomeFrom",
      "incomeTo",
      "initialAssignedUser",
    ];
    const parsedValue = numberFields.includes(name)
      ? value === ""
        ? ""
        : Number(value)
      : value;

    if (name === "assignType") {
      setFormData((prev) => ({
        ...prev,
        assignType: value,
        initialAssignedUser:
          value === "self"
            ? parseInt(localStorage.getItem("UserId") ?? "0")
            : prev.initialAssignedUser,
        currentAssignedUser:
          value === "self"
            ? parseInt(localStorage.getItem("UserId") ?? "0")
            : prev.currentAssignedUser,
      }));
      if (value === "self") {
        setSelectedAssignUserId(
          parseInt(localStorage.getItem("UserId") ?? "0")
        );
      } else {
        setSelectedAssignUserId(null);
      }
    } else if (name === "initialAssignedUser") {
      setSelectedAssignUserId(parseInt(value));
      setFormData((prev) => ({
        ...prev,
        initialAssignedUser: parseInt(value),
        currentAssignedUser: parseInt(value),
      }));
    } else if (name === "mobile") {
      if (value !== "" && !/^\d*$/.test(value)) {
        return;
      }
      setFormData((prev) => ({
        ...prev,
        mobile: value, // Explicitly use value as string for mobile
      }));
    } else if (name === "stateId") {
      setFormData((prev) => ({
        ...prev,
        [name]: parseInt(value),
        districtId: 0,
        cityId: 0,
      }));
    } else if (
      name === "districtId" ||
      name === "cityId" ||
      name === "sourceId" ||
      name === "subSourceId"
    ) {
      setFormData((prev) => ({
        ...prev,
        [name]: parseInt(value),
        ...(name === "sourceId" && { subSourceId: 0 }),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: parsedValue,
      }));
    }
  };

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  const validateForm = (): boolean => {
    const newErrors: ValidationErrors = {};
    let isValid = true;

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
      isValid = false;
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
      isValid = false;
    }
    if (!formData.gender.trim()) {
      newErrors.gender = "Please select Gender";
      isValid = false;
    }
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
      isValid = false;
    } else if (!validateMobile(formData.mobile)) {
      newErrors.mobile = "Mobile number should contain only digits";
      isValid = false;
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email format";
      isValid = false;
    }
    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
      isValid = false;
    }
    if (!formData.stateId) {
      newErrors.stateId = "Please select a State";
      isValid = false;
    }
    if (!formData.districtId) {
      newErrors.districtId = "Please select a District";
      isValid = false;
    }
    if (!formData.cityId) {
      newErrors.cityId = "Please select a City";
      isValid = false;
    }
    if (!formData.zipCode) {
      newErrors.zipCode = "Zip code is required";
      isValid = false;
    }
    if (!formData.sourceId) {
      newErrors.sourceId = "Please select a Source";
      isValid = false;
    }
    // if (!formData.subSourceId) {
    //   newErrors.subSourceId = "Please select a Subsource";
    //   isValid = false;
    // }
    if (!formData.assignType) {
      newErrors.assignType = "Please select an Assign Type";
      isValid = false;
    }
    if (formData.assignType === "assign" && !formData.initialAssignedUser) {
      newErrors.initialAssignedUser = "Please select a user to assign";
      isValid = false;
    }

    setError(newErrors);
    console.log("Form errors:", newErrors);
    return isValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      //toast.error("Please fix the errors in the form");
      return;
    }

    try {
      setIsLoading(true);
      const userId = localStorage.getItem("UserId");
      const tenantId = localStorage.getItem("tenantId");

      if (!userId || !tenantId) {
        throw new Error("User ID or Tenant ID not found in localStorage");
      }

      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        gender: formData.gender,
        dob: formData.dob,
        dom: formData.dom,
        mobile: formData.mobile,
        email: formData.email,
        address: formData.address,
        stateId: formData.stateId,
        districtId: formData.districtId,
        cityId: formData.cityId,
        zipCode: Number(formData.zipCode) || 0,
        sourceId: formData.sourceId,
        subSourceId: formData.subSourceId,
        currentStatus: 1,
        incomeFrom: Number(formData.incomeFrom) || 0,
        incomeTo: Number(formData.incomeTo) || 0,
        initialAssignedUser: formData.initialAssignedUser,
        currentAssignedUser: formData.currentAssignedUser,
        tenantId: parseInt(tenantId),
        createdBy: parseInt(userId),
        assignType: formData.assignType,
      };

      console.log(payload);
      //const result = await createLead(payload);

      // if (result.isCreated) {
      //   toast.success(result.message || "Lead Created Successfully!");
      //   setFormData({
      //     firstName: "",
      //     lastName: "",
      //     gender: "",
      //     dob: "",
      //     dom: "",
      //     mobile: "",
      //     email: "",
      //     address: "",
      //     stateId: 0,
      //     districtId: 0,
      //     cityId: 0,
      //     zipCode: "",
      //     sourceId: 0,
      //     subSourceId: 0,
      //     currentStatus: 0,
      //     incomeFrom: "",
      //     incomeTo: "",
      //     initialAssignedUser: 0,
      //     currentAssignedUser: 0,
      //     tenantId: 0,
      //     createdBy: 0,
      //     assignType: "assign",
      //   });
      //   setSelectedAssignUserId(null);
      // } else {
      //   throw new Error(result.message || "Failed to create lead");
      // }
    } catch (err) {
      const newErrors: ValidationErrors = {};
      newErrors.submitError = "An error occurred while creating the lead";
      setError(newErrors);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="wrapper">
      <div>
        <Toaster
          position="top-center"
          reverseOrder={false}
          containerStyle={{
            zIndex: 10000,
          }}
        />
      </div>
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0"></div>

            <div className="card">
              <ul
                className="nav nav-tabs cardHeaderHegiht"
                id="myTab"
                role="tablist"
                style={{ borderBottom: "1px solid #84556b" }}
              >
                <li className="nav-item tabHeaderPadding" role="presentation">
                  <button
                    className={`nav-link card-title tab-btn cardHeaderHegiht ${
                      activeTab === "home" ? "active" : ""
                    }`}
                    id="home-tab"
                    onClick={() => handleTabClick("home")}
                    type="button"
                    role="tab"
                    aria-controls="home-tab-pane"
                    aria-selected={activeTab === "home"}
                  >
                    Lead Details
                  </button>
                </li>
                <li className="nav-item tabHeaderPadding" role="presentation">
                  <button
                    className={`nav-link card-title tab-btn cardHeaderHegiht ${
                      activeTab === "files" ? "active" : ""
                    }`}
                    id="files-tab"
                    onClick={() => handleTabClick("files")}
                    type="button"
                    role="tab"
                    aria-controls="files-tab-pane"
                    aria-selected={activeTab === "files"}
                  >
                    Other Details
                  </button>
                </li>
              </ul>

              <div className="tab-content card-body" id="myTabContent">
                <div
                  className={`tab-pane fade ${
                    activeTab === "home" ? "show active" : ""
                  }`}
                  id="home-tab-pane"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                  tabIndex={0}
                >
                  <form onSubmit={handleSubmit}>
                    <div className="row mb-3 ">
                      <div className="col-12 col-lg-6 mb-3">
                        <div>
                          <label htmlFor="firstName" className="form-label">
                            First Name{requiredField}
                          </label>
                          <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            className={`form-control form-control-lg ${
                              error.firstName ? "is-invalid" : ""
                            }`}
                            placeholder="Enter First Name"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            required
                          />
                          {error.firstName && (
                            <div className="invalid-feedback text-danger">
                              {error.firstName}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <div>
                          <label htmlFor="lastName" className="form-label">
                            Last Name{requiredField}
                          </label>
                          <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            className={`form-control form-control-lg ${
                              error.lastName ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Last Name"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            required
                          />
                          {error.lastName && (
                            <div className="invalid-feedback text-danger">
                              {error.lastName}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <div>
                          <label htmlFor="gender" className="form-label">
                            Gender{requiredField}
                          </label>
                          <select
                            id="gender"
                            name="gender"
                            value={formData.gender}
                            onChange={handleInputChange}
                            className={`form-control form-control-lg ${
                              error.gender ? "is-invalid" : ""
                            }`}
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                          </select>
                          {error.gender && (
                            <div className="invalid-feedback text-danger">
                              {error.gender}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <div>
                          <label htmlFor="dob" className="form-label">
                            DOB
                          </label>
                          <input
                            type="datetime-local"
                            id="dob"
                            name="dob"
                            className={`form-control form-control-lg ${
                              error.dob ? "is-invalid" : ""
                            }`}
                            placeholder="Enter DOB"
                            value={formData.dob}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <label htmlFor="dom" className="form-label">
                          DOM
                        </label>
                        <input
                          type="datetime-local"
                          id="dom"
                          name="dom"
                          className={`form-control form-control-lg ${
                            error.dom ? "is-invalid" : ""
                          }`}
                          placeholder="Enter DOM"
                          value={formData.dom}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <div className="">
                          <label htmlFor="mobile" className="form-label">
                            Mobile{requiredField}
                          </label>
                          <input
                            id="mobile"
                            name="mobile"
                            className={`form-control form-control-lg ${
                              error.mobile ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Mobile No"
                            value={formData.mobile}
                            onChange={handleInputChange}
                            required
                          />
                          {error.mobile && (
                            <div className="invalid-feedback text-danger">
                              {error.mobile}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <div>
                          <label htmlFor="email" className="form-label">
                            Email{requiredField}
                          </label>
                          <input
                            type="text"
                            id="email"
                            name="email"
                            className={`form-control form-control-lg ${
                              error.email ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                          />
                          {error.email && (
                            <div className="invalid-feedback text-danger">
                              {error.email}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <label htmlFor="address" className="form-label">
                          Address{requiredField}
                        </label>
                        <textarea
                          onChange={handleInputChange}
                          id="address"
                          name="address"
                          className={`form-control form-control-lg ${
                            error.address ? "is-invalid" : ""
                          }`}
                          placeholder="Enter Address"
                          value={formData.address}
                          required
                        />
                        {error.address && (
                          <div className="invalid-feedback text-danger">
                            {error.address}
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>

                <div
                  className={`tab-pane fade ${
                    activeTab === "files" ? "show active" : ""
                  }`}
                  id="files-tab-pane"
                  role="tabpanel"
                  aria-labelledby="files-tab"
                  tabIndex={0}
                >
                  <form onSubmit={handleSubmit}>
                    <div className="row mb-3 ">
                      <div className="col-12 col-lg-6 mb-3">
                        <label htmlFor="stateId" className="form-label">
                          State{requiredField}
                        </label>
                        {isLoadingStates ? (
                          <div className="text-muted">Loading states...</div>
                        ) : (
                          <select
                            id="stateId"
                            name="stateId"
                            className={`form-control form-control-lg ${
                              error.stateId ? "is-invalid" : ""
                            }`}
                            value={formData.stateId ?? ""}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select State</option>
                            {states.map((state) => (
                              <option key={state.stateId} value={state.stateId}>
                                {state.stateName}
                              </option>
                            ))}
                          </select>
                        )}
                        {error.stateId && (
                          <div className="invalid-feedback text-danger">
                            {error.stateId}
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <label htmlFor="districtId" className="form-label">
                          District{requiredField}
                        </label>
                        {isLoadingDistricts ? (
                          <div className="text-muted">Loading districts...</div>
                        ) : (
                          <select
                            id="districtId"
                            name="districtId"
                            className={`form-control form-control-lg ${
                              error.districtId ? "is-invalid" : ""
                            }`}
                            value={formData.districtId ?? ""}
                            onChange={handleInputChange}
                            required
                            disabled={!formData.stateId}
                          >
                            <option value="">
                              {formData.stateId
                                ? filteredDistricts.length > 0
                                  ? "Select District"
                                  : "No districts available"
                                : "Select state first"}
                            </option>
                            {filteredDistricts.map((district) => (
                              <option
                                key={district.districtId}
                                value={district.districtId}
                              >
                                {district.districtName}
                              </option>
                            ))}
                          </select>
                        )}
                        {error.districtId && (
                          <div className="invalid-feedback text-danger">
                            {error.districtId}
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <label htmlFor="cityId" className="form-label">
                          City{requiredField}
                        </label>
                        {isLoadingCities ? (
                          <div className="text-muted">Loading cities...</div>
                        ) : (
                          <select
                            id="cityId"
                            name="cityId"
                            className={`form-control form-control-lg ${
                              error.cityId ? "is-invalid" : ""
                            }`}
                            value={formData.cityId ?? ""}
                            onChange={handleInputChange}
                            required
                            disabled={!formData.districtId}
                          >
                            <option value="">
                              {formData.districtId
                                ? filteredCities.length > 0
                                  ? "Select City"
                                  : "No cities available"
                                : "Select district first"}
                            </option>
                            {filteredCities.map((city) => (
                              <option key={city.cityId} value={city.cityId}>
                                {city.cityName}
                              </option>
                            ))}
                          </select>
                        )}
                        {error.cityId && (
                          <div className="invalid-feedback text-danger">
                            {error.cityId}
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <label htmlFor="zipCode" className="form-label">
                          Zipcode{requiredField}
                        </label>
                        <input
                          type="text"
                          id="zipCode"
                          name="zipCode"
                          className={`form-control form-control-lg ${
                            error.zipCode ? "is-invalid" : ""
                          }`}
                          placeholder="Enter Zipcode"
                          value={formData.zipCode}
                          onChange={handleInputChange}
                          required
                        />
                        {error.zipCode && (
                          <div className="invalid-feedback text-danger">
                            {error.zipCode}
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <label htmlFor="sourceId" className="form-label">
                          Source{requiredField}
                        </label>
                        {isLoadingSourceMedia ? (
                          <div className="text-muted">Loading source...</div>
                        ) : (
                          <select
                            id="sourceId"
                            name="sourceId"
                            className={`form-control form-control-lg ${
                              error.sourceId ? "is-invalid" : ""
                            }`}
                            value={formData.sourceId ?? ""}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select Source</option>
                            {mediaSource.map((src) => (
                              <option key={src.sourceId} value={src.sourceId}>
                                {src.sourceName}
                              </option>
                            ))}
                          </select>
                        )}
                        {error.sourceId && (
                          <div className="invalid-feedback text-danger">
                            {error.sourceId}
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <label htmlFor="subSourceId" className="form-label">
                          Sub Source{requiredField}
                        </label>
                        {isLoadingSubSourceMedia ? (
                          <div className="text-muted">
                            Loading sub source...
                          </div>
                        ) : (
                          <select
                            id="subSourceId"
                            name="subSourceId"
                            className={`form-control form-control-lg ${
                              error.subSourceId ? "is-invalid" : ""
                            }`}
                            value={formData.subSourceId ?? ""}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">
                              {formData.sourceId
                                ? filteredSubMediaSource.length > 0
                                  ? "Select Sub Source"
                                  : "No sub source available"
                                : "Select source first"}
                            </option>
                            {filteredSubMediaSource.map((ssrc) => (
                              <option key={ssrc.id} value={ssrc.id}>
                                {ssrc.name}
                              </option>
                            ))}
                          </select>
                        )}
                        {error.subSourceId && (
                          <div className="invalid-feedback text-danger">
                            {error.subSourceId}
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <div>
                          <label htmlFor="incomeFrom" className="form-label">
                            Income From
                          </label>
                          <input
                            type="text"
                            id="incomeFrom"
                            name="incomeFrom"
                            className={`form-control form-control-lg ${
                              error.incomeFrom ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Income From"
                            value={formData.incomeFrom}
                            onChange={handleInputChange}
                          />
                          {error.incomeFrom && (
                            <div className="invalid-feedback text-danger">
                              {error.incomeFrom}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <div>
                          <label htmlFor="incomeTo" className="form-label">
                            Income To
                          </label>
                          <input
                            type="text"
                            id="incomeTo"
                            name="incomeTo"
                            className={`form-control form-control-lg ${
                              error.incomeTo ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Income To"
                            value={formData.incomeTo}
                            onChange={handleInputChange}
                          />
                          {error.incomeTo && (
                            <div className="invalid-feedback text-danger">
                              {error.incomeTo}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <label className="form-label d-block mb-2">
                          Assign Type{requiredField}
                        </label>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="assign"
                            name="assignType"
                            value="assign"
                            checked={formData.assignType === "assign"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="assign">
                            Assign
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="self"
                            name="assignType"
                            value="self"
                            checked={formData.assignType === "self"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="self">
                            Self
                          </label>
                        </div>
                        {error.assignType && (
                          <div className="invalid-feedback text-danger d-block">
                            {error.assignType}
                          </div>
                        )}
                      </div>

                      {formData.assignType === "assign" && (
                        <div className="col-12 col-lg-6 mb-3">
                          <label
                            htmlFor="initialAssignedUser"
                            className="form-label"
                          >
                            Assign to User{requiredField}
                          </label>
                          <select
                            id="initialAssignedUser"
                            name="initialAssignedUser"
                            className={`form-control form-control-lg ${
                              error.initialAssignedUser ? "is-invalid" : ""
                            }`}
                            value={formData.initialAssignedUser ?? ""}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select User</option>
                            {assignedUser.map((usr) => (
                              <option key={usr.userId} value={usr.userId}>
                                {usr.userName}
                              </option>
                            ))}
                          </select>
                          {error.initialAssignedUser && (
                            <div className="invalid-feedback text-danger">
                              {error.initialAssignedUser}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </form>
                </div>

                <div className="">
                  {activeTab !== "home" ? (
                    <>
                      <button
                        type="submit"
                        className="btn btn-primary me-2 mt-4"
                        onClick={handleSubmit}
                        disabled={isLoading}
                      >
                        {isLoading ? "Submitting..." : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary mt-4"
                        onClick={() => navigate("/leadview")}
                      >
                        <i className="bi bi-arrow-return-left"></i> Back To List
                      </button>
                    </>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => navigate("/leadview")}
                    >
                      <i className="bi bi-arrow-return-left"></i> Back To List
                    </button>
                  )}
                </div>
              </div>
            </div>
          </main>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default CreateLeadForm;
